import React from 'react';

export default function NewsletterSignup(props) {
  console.log('NEWSLETTER SIGNUP: ', props);

  return <>
    <div className="fragment-title">Sign up for our newsletter</div>
    <div>
      <input type='text' className='form-control' placeholder='Email Address'/>
      <button style={{marginTop: 20}} type='submit' className='btn btn-primary'>Signup</button>
    </div>
  </>;
}
